var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,32h-72V0H100.688L0,100.688V496h400V192h72c13.232,0,24-10.768,24-24V56C496,42.768,485.232,32,472,32z M96,27.312 V96H27.312L96,27.312z M384,480H16V112h96V16h272v16H184c-13.232,0-24,10.768-24,24v112c0,13.232,10.768,24,24,24h200V480z  M480,168c0,4.408-3.592,8-8,8H184c-4.408,0-8-3.592-8-8V56c0-4.408,3.592-8,8-8h288c4.408,0,8,3.592,8,8V168z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 16,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,72 V152 H214 Q240,152 240,126 V98 Q240,72 214,72 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 72,
    width: 40,
    height: 80,
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,72 H364 Q344,72 344,92 V132 Q344,152 364,152 H384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,64 L459,160 M459,64 L413,160",
    strokeLinecap: "butt"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 232,
    width: 272,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 280,
    width: 272,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 328,
    width: 272,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 376,
    width: 272,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 424,
    width: 176,
    height: 16
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word-icon.03e763b0848f55c7c911e5b88a5d3a91.svg";
export { ForwardRef as ReactComponent };